const isDev = process.env.NODE_ENV === "development"


export default {
    // baseApi: "https://crbt.cdyrjygs.com/cms-vrbt/api",
    baseApi: "cms-vrbt/api",//李 测试
    // 检测是否是开发环境
    BASE_URL: isDev ? "/" : "/jnb",
}